import React from "react";
import { Create, Edit, useForm } from "@refinedev/antd";
import { Form } from "antd";
import type { FieldDef } from "@evo-flywheel/contracts";
import { useResource } from "@refinedev/core";
import { resourceBySlug } from "../kit-resources";
import { FormField } from "../fields";
import { EditSlots, getCurrentUserId } from "@evo-flywheel/ui";

export const GenericCreate: React.FC = () => {
  const { resource } = useResource(); const meta = resourceBySlug[resource?.name ?? ""]?.meta; const { formProps, saveButtonProps } = useForm();
  const fields = new Map<string, FieldDef>((meta?.fields ?? []).map((field) => [field.name, field])); const view = meta?.createView;
  return <Create saveButtonProps={saveButtonProps}><Form {...formProps} layout="vertical">{(view?.fields ?? []).map((name) => { const field = fields.get(name); return field ? <FormField key={name} field={field} slug={resource?.name} required={view?.required.includes(name)} initialValue={view?.defaults[name] ?? (name === "assigned_user_id" ? getCurrentUserId() : undefined)} /> : null; })}</Form></Create>;
};

export const GenericEdit: React.FC = () => {
  const { resource } = useResource(); const meta = resourceBySlug[resource?.name ?? ""]?.meta; const { formProps, saveButtonProps } = useForm();
  const fields = new Map<string, FieldDef>((meta?.fields ?? []).map((field) => [field.name, field]));
  const record = formProps.initialValues as Record<string, unknown> | undefined;
  return <Edit saveButtonProps={saveButtonProps}><EditSlots slug={resource?.name} record={record} /><Form {...formProps} layout="vertical">{(meta?.editView ?? []).map((name) => { const field = fields.get(name); return field ? <FormField key={name} field={field} slug={resource?.name} required={name === "assigned_user_id"} /> : null; })}</Form></Edit>;
};
